import { Route } from "react-router-dom";

import CreateProductionProducer from "../pages/CreateProductionProducer";
import CreateProductionPublisher from "../pages/CreateProductionPublisher";

export const createProductionPublisher = <Route path="create-production" element={<CreateProductionPublisher />} />;

export const createProductionProducer = <Route path="create-production" element={<CreateProductionProducer />} />;
